import { IProfileState } from "./interface";

export default <IProfileState> {
	profile: {
		flCrmId: 0,
		ulCrmId: 0,
		mfoUl: '',
		nciId: '',
		ulName: '',
	},
	digitalSign: null,
	company: null
}